import Feedback from '../feedback';

/**
 * Create the action
 */

const { thunk, request, success, error } = Feedback.destroy((id, fetch) => {
    return fetch.delete(`/feedback/${id}`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
